<template>
  <div class="interest-public">
    <div class="container">
      <!-- 顶部 提示信息 -->
      <div class="header">
        <span>
          打开微信，扫一扫下方二维码关注
          <span class="red">{{ productName }}</span> 公众号，进入公众号后点击菜单，在打开的页面中输入下方显示的<span class="red">验证码</span>，单击订阅按钮后即可完成绑定
        </span>
      </div>
      <!-- 中间 二维码 -->
      <div class="center">
        <img ref="qrcode111" src="#" alt="" />
      </div>
      <!-- 底部 验证码 -->
      <div class="footer">
        <div class="main">
          <div class="label">
            <span>验证码：</span>
          </div>
          <div class="num">
            <span class="point" v-show="!codeVisible">·</span>
            <span class="word" v-show="codeVisible">{{ word.num1 }}</span>
          </div>
          <div class="num">
            <span class="point" v-show="!codeVisible">·</span>
            <span class="word" v-show="codeVisible">{{ word.num2 }}</span>
          </div>
          <div class="num">
            <span class="point" v-show="!codeVisible">·</span>
            <span class="word" v-show="codeVisible">{{ word.num3 }}</span>
          </div>
          <div class="num">
            <span class="point" v-show="!codeVisible">·</span>
            <span class="word" v-show="codeVisible">{{ word.num4 }}</span>
          </div>
        </div>
        <div class="eye" @click="onSvgEveClick">
          <svg-icon :icon-class="svgEyePath" class-name="cur-icon"></svg-icon>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btn-row">
        <mt-button type="primary" size="large" @click="onShareClick">
          分享二维码
        </mt-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { setTimeout } from 'timers';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { GetRandomCode } from '@/api/official';
import { CusToast } from '@/utils/CustomToast';

export default {
  name: 'InterestPublicCode',
  data() {
    return {
      // imgPath: require("@/assets/qrcode_for_interest_test.jpg"),
      imgPath: 'image/official_account_qrcode.jpg',
      productName: '易付通',
      codeVisible: true,
      svgEyePath: 'show_money', // hide_money
      word: {
        num1: '',
        num2: '',
        num3: '',
        num4: '',
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initData();
    });
  },
  methods: {
    // 初始化页面
    initData() {
      this.initImage();
      this.getRandomCode();
    },
    initImage() {
      const r = '?r=' + new Date().getFullYear() + new Date().getMonth() + new Date().getDate() + new Date().getHours() + new Date().getMinutes() + new Date().getSeconds();
      this.$refs['qrcode111'].src = this.imgPath + r;
    },
    // 返回随机数
    getRandomCode() {
      Indicator.open();
      GetRandomCode()
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              const code = res.data.randomCode;
              if (code) {
                this.word.num1 = String(code).charAt(0);
                this.word.num2 = String(code).charAt(1);
                this.word.num3 = String(code).charAt(2);
                this.word.num4 = String(code).charAt(3);
              } else {
                CusToast('随机码为空，无法显示');
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 分享按钮点击事件
    onShareClick() {
      this.codeVisible = false;
      this.svgEyePath = 'hide_money';
      setTimeout(() => {
        window.location.href = 'share://android';
      }, 750);
    },
    // 眼睛的点击事件
    onSvgEveClick() {
      if (this.codeVisible) {
        this.codeVisible = false;
        this.svgEyePath = 'hide_money';
      } else {
        this.codeVisible = true;
        this.svgEyePath = 'show_money';
      }
    },
    // 返回的点击事件
    onBackClick() {
      window.location.href = 'protocol://android';
    },
  },
};
</script>
